export const DOWNLOAD_ORDERS_STEPS = ['Descargar plantilla', 'Subir plantilla', 'Resumen'];